import React from 'react';

// CloseIcon
type CloseIconProps = React.SVGProps<SVGSVGElement>;

export const CloseIcon: React.FC<CloseIconProps> = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill="#fff"
    />
  </svg>
);
